import { securedAxios } from '../axios'
import { IGameUser, IUser } from './types/user'
import { IChatMessagePage } from './types/chat'
import { IGame } from './types/game'
import { IDocument } from './types/document'
import {
  ICharacter,
  ICharacterEffect,
  ICharacterItem,
  IGameCharacter,
  IRace,
} from './types/character'
import { IAction } from './types/action'
import { IItem } from './types/item'
import { ISpell } from './types/spell'

export const queryCurrentUser = async () => {
  const { data } = await securedAxios.get<IUser>('/users/current')
  return data
}

export const queryUser = async (user_id: string) => {
  const { data } = await securedAxios.get<IUser>(`/users/${user_id}`)
  return data
}

export const queryUsers = async () => {
  const { data } = await securedAxios.get<IUser[]>('/users')
  return data
}

export const queryItems = async () => {
  const { data } = await securedAxios.get<IItem[]>('/items')
  return data
}

export const queryItem = async (item_id: number) => {
  const { data } = await securedAxios.get<IItem>(`/items/${item_id}`)
  return data
}

export const querySpells = async () => {
  const { data } = await securedAxios.get<ISpell[]>('/spells')
  return data
}

export const queryGames = async () => {
  const { data } = await securedAxios.get<IGame[]>('/games')
  return data
}

export const queryGame = async (game_slug: string) => {
  const { data } = await securedAxios.get<IGame>(`/games/${game_slug}`)
  return data
}

export const queryGameCharacters = async (game_slug: string) => {
  const { data } = await securedAxios.get<IGameCharacter[]>(`/games/${game_slug}/characters`)
  return data
}

export const queryHelp = async () => {
  const { data } = await securedAxios.get<IDocument>(`/help`)
  return data
}

export const queryChatMessagesPage = async (game_id: number, page: number, perPage: number) => {
  const { data } = await securedAxios.get<IChatMessagePage>(
    `/chat_messages?game_id=${game_id}&page=${page}&per_page=${perPage}`
  )
  return data
}

export const queryOnlineUsers = async (game_slug: string) => {
  const { data } = await securedAxios.get<IGameUser[]>(`/games/${game_slug}/online_users`)
  return data
}

export const queryRacesBase = async () => {
  const { data } = await securedAxios.get<IRace[]>(`/races/base`)
  return data
}

export const queryCharacter = async (id: number) => {
  const { data } = await securedAxios.get<ICharacter>(`/characters/${id}`)
  return data
}

export const queryPendingActions = async (game_id: number) => {
  const { data } = await securedAxios.get<IAction[]>(`/actions/pending?game_id=${game_id}`)
  return data
}

export const queryCharacterInventory = async (char_id: number) => {
  const { data } = await securedAxios.get<ICharacterItem[]>(`/characters/${char_id}/items`)
  return data
}

export const queryCharacterEffects = async (char_id: number) => {
  const { data } = await securedAxios.get<ICharacterEffect[]>(`/characters/${char_id}/effects`)
  return data
}

export const userQueryKey = (id: number) => ['user', id]
export const itemQueryKey = (id: number) => ['item', id]
export const usersQueryKey = () => ['users']
export const itemsQueryKey = () => ['items']
export const spellsQueryKey = () => ['spells']
export const gameQueryKey = (id: string) => ['game', id]
export const gamesQueryKey = () => ['games']
export const helpQueryKey = () => ['help']
export const characterQueryKey = (id: number) => ['character', id]
export const racesBaseQueryKey = () => ['races_base']
export const authQueryKey = () => ['current_user']
export const gameCharsQueryKey = (game_id: number) => ['game_chars', game_id]
export const pendingActionsQueryKey = (game_id: number) => ['pending_actions', game_id]
export const characterInventoryQueryKey = (char_id: number) => ['character_inventory', char_id]
export const characterEffectsQueryKey = (char_id: number) => ['character_effects', char_id]
